import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { qarepaHttpInterceptors } from '@qarepa/common';
import { CoreModule } from '@qaroni-merchant-core/core.module';
import { provideApiBaseUrl } from '@qaroni-merchant-core/providers/provide-api-base-url.provider';
import { provideApiError } from '@qaroni-merchant-core/providers/provide-api-error.provider';
import { provideInitialize } from '@qaroni-merchant-core/providers/provide-initializer.provider';
import { provideSentry } from '@qaroni-merchant-core/providers/provide-sentry.provider';
import { provideDocumentLang } from 'libono';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, CoreModule),
    provideAnimations(),
    provideRouter(routes, withHashLocation()),
    provideInitialize(),
    provideDocumentLang(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors(qarepaHttpInterceptors)
    ),
    provideApiBaseUrl(),
    provideApiError(),
    provideSentry(),
  ],
};
